import CssBaseline from '@mui/material/CssBaseline';
import { Buffer } from 'buffer';
import ActivityErrorBoundary from 'components/ActivityErrorBoundary';
import ReactDOM from 'react-dom/client';
import { configureActivityTracking } from 'services/activity';
import App from './App';
import './index.css';
import './locales';

window.Buffer = window.Buffer || Buffer;
configureActivityTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <CssBaseline />
        <ActivityErrorBoundary>
            <App />
        </ActivityErrorBoundary>
    </>
);
